import React from "react"

const ThreadsListEmpty = ({ category, list, message }) => {
  if (list.type === "all") {
    if (message) {
      return (
        <li className="list-group-item empty-message">
          <p className="lead">{message}</p>
        </li>
      )
    }

    return (
      <li className="list-group-item empty-message">
        <p className="lead">
          {category.special_role
            ? pgettext(
                "zones list empty",
                "There are no zones on this site yet."
              )
            : pgettext(
                "zones list empty",
                "There are no zones in this category."
              )}
        </p>
      </li>
    )
  }

  return (
    <li className="list-group-item empty-message">
      <p className="lead">
        {pgettext(
          "zones list empty",
          "No zones matching specified criteria were found."
        )}
      </p>
    </li>
  )
}

export default ThreadsListEmpty
